import React from "react";
import {
  Box,
  Typography,
  Chip,
  Avatar,
  AvatarGroup,
  IconButton,
  Paper,
  Grid,
  Button
} from "@mui/material";

import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import DeleteIcon from "@mui/icons-material/Delete";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { Visibility } from "@mui/icons-material";

import moment from "moment";
import Style from "style-it";
import { checkPrivileges } from "../../Helpers";

const TaskList = ({
  tasks = [],
  handleView,
  handleEdit,
  handleDelete,
  pagination,
  onPageChange,
  translate
}) => {

  const statusColor = {
    New: "#4CAF50",
    Assigned: "#FF9800",
    "In Progress": "#2196F3",
    "Awaiting Customer Response": "#FFC107",
    Resolved: "#9C27B0",
    Closed: "#E53935"
  };
  const isFirstPage = pagination?.currentPage == 1;
  const isLastPage = !pagination?.hasNext;
  return (
    <>
      <Style>
        {`
        .main-content-page .MuiPaper-root {
          background: #F1F8EC !important;
        }
      `}
      </Style>

      <Box>
        {tasks.length === 0 && (
          <Paper
            elevation={0}
            sx={{
              p: 4,
              textAlign: "center",
              background: "#F1F8EC"
            }}
          >
            <Typography variant="h6" color="text.secondary">
              {translate("nodataFound")}
            </Typography>
          </Paper>
        )}


        {tasks.map((task, index) => (
          <Paper
            key={index}
            elevation={0}
            sx={{
              p: 2,
              mb: 2,
              borderRadius: 1,
              backgroundColor: "#F1F8EC",
              borderLeft: `6px solid ${statusColor[task.currentStatus]}`,
              borderBottom: "1px solid #6FBD43"
            }}
          >
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={12} sm={3} md={2}>
                <Typography fontWeight="bold" noWrap>
                  {task.name}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  ID {task.id}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={2} md={1}>
                <Chip
                  label={translate(task.currentStatus)}
                  size="small"
                  sx={{
                    backgroundColor:
                      statusColor[task.currentStatus] || "#ccc",
                    color: "#fff",
                    fontWeight: "bold"
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={2} md={2} sx={{ display: "flex", alignItems: "center" }}>
                <CalendarTodayIcon sx={{ fontSize: 16, mr: 0.5 }} />
                <Typography variant="body2">
                  {moment(task.date).format("ddd, DD MMM YYYY")}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={3} md={2} sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="body2" fontWeight={600}>CN: </Typography>
                <Typography variant="body2">{task?.contractNumber || "-"}</Typography>

              </Grid>
              <Grid item xs={12} sm={4} md={2} sx={{ display: "flex", flexDirection: "column", gap: 1 }}>

                <Box display={"flex"} alignItems={"center"} gap={1}>
                  <Typography variant="body2" fontWeight={600}>{translate("ticketType")}:</Typography>
                  <Typography variant="body2">    {task?.ticketType
                    ? task.ticketType.charAt(0).toUpperCase() + task.ticketType.slice(1).toLowerCase()
                    : "-"}</Typography>
                </Box>

                <Box display={"flex"} alignItems={"center"} gap={1}>
                  <Typography variant="body2" fontWeight={600}>{translate("department")}:</Typography>
                  <Typography variant="body2">    {task?.department
                    ? task.department.charAt(0).toUpperCase() + task.department.slice(1).toLowerCase()
                    : "-"}</Typography>
                </Box>

              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={3}
                sx={{
                  display: "flex",
                  justifyContent: { xs: "flex-start", md: "flex-end" },
                  gap: 1
                }}
              >
                
                <IconButton
                  sx={{ backgroundColor: "#6cc04a", color: "#fff" }}
                  onClick={() => handleView(task)}
                >
                  <Visibility fontSize="small" />
                </IconButton>

                <IconButton
                  sx={{ backgroundColor: "#6cc04a", color: "#fff" }}
                  onClick={() => handleEdit(task)}
                >
                  <OpenInNewIcon fontSize="small" />
                </IconButton>

{checkPrivileges("ticketDelete")&&
                <IconButton
                  sx={{ backgroundColor: "#f44336", color: "#fff" }}
                  onClick={() => handleDelete(task)}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>}
              </Grid>
            </Grid>
          </Paper>
        ))}

        {pagination && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 3,
              flexWrap: "wrap"
            }}
          >
            <Button
              startIcon={<FirstPageIcon />}
              onClick={() => onPageChange("first")}
              disabled={isFirstPage}
            >
              {translate("goToPage")} 1
            </Button>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography>
                {translate("totalRecords")} {pagination.total}
              </Typography>
              <Button
                variant="outlined"
                size="small"
                onClick={() => onPageChange("prev")}
                disabled={isFirstPage}
              >
                <KeyboardBackspaceIcon />
              </Button>
              <Button
                onClick={() => onPageChange("next")}
                endIcon={<ArrowRightAltIcon />}
                disabled={isLastPage}
              >
                {translate("next")}
              </Button>
              <Typography>
                {translate("page")} {pagination.currentPage} {translate("of")}{" "}
                {Math.ceil(pagination.total / pagination.pageSize)}
              </Typography>

            </Box>
            <Button
              endIcon={<LastPageIcon />}
              onClick={() => onPageChange("last")}
              disabled={isLastPage}
            >
              {translate("goToLastPage")}
            </Button>

          </Box>
        )}
      </Box>
    </>
  );
};

export default TaskList;